import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { nothing as w, html as $ } from '../../../../../node_modules/lit-html/lit-html.js';
import '../../../../../node_modules/lit-element/lit-element.js';

function buildSelectOptions(options) {
    if (!options || options.length === 0) {
        return w;
    }
    const optionTemplates = options.map(optionLabel => $ `<option value="${optionLabel}">${optionLabel}</option>`);
    return $ `${optionTemplates}`;
}

export { buildSelectOptions };
